import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PotentialMembersdetailPage } from './potential-membersdetail.page';

const routes: Routes = [
  {
    path: '',
    component: PotentialMembersdetailPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PotentialMembersdetailPage]
})
export class PotentialMembersdetailPageModule {}
